import React from 'react'

import TableFirstColumn from './components/TableFirstColumn'
import { HideItemButton, DeleteItemButton } from './actions'

export default [
  {
    prop: 'data.name',
    header: 'Name',
    render: ({ id, data, media }) => (
      <TableFirstColumn image={media[0]} title={data.title} link={id} />
    ),
  },
  { prop: 'data.address', header: 'Address' },
  { prop: 'data.capacity', header: 'Capacity' },
  HideItemButton,
  DeleteItemButton,
]
